







































import Vue from "vue";
import router from "@/router";
import {
  RESET_PASSWORD_SMS,
  RESET_PASSWORD_EMAIL,
} from "@/services/types/resetPassword.type";
import identityAuthenClient from "@/services/identityAuthenClient";
import allCountries from "@/modules/vuetifyx/utils/all-countries";
import SignOut from "../partials/SignOut.vue";

export default Vue.extend({
  name: "ForgotPassword",
  components: { SignOut },
  data() {
    return {
      itemsCode: [],
      form: false,
      error: "",
      inputData: "",
      isWaiting: false,
    };
  },
  methods: {
    goBack() {
      router.push("/login");
    },
    async requestChangePassword() {
      this.isWaiting = true;
      const query: any = {
        loginName: this.inputData,
      };
      try {
        const data = await identityAuthenClient.requestChangePassword(query);
        if (data) {
          const errorInfo = data.error_info;
          if (
            errorInfo &&
            errorInfo.message !== "" &&
            Object.keys(errorInfo).length
          ) {
            this.error = errorInfo.message;
            this.isWaiting = false;
            return;
          }
          data.query = query;
          if (data.available_types && data.available_types.length > 0) {
            router.push({ name: "forgot-password-otp", params: data });
          } else {
            router.push({ name: "forgot-password-result", params: data });
          }
        }
      } catch (error) {
        this.error = error;
      }
    },
    preventReload(event) {
      event.preventDefault();
    },
  },
  created() {
    if (allCountries.length > 0) {
      this.itemsCode = allCountries.map((country) => country[2]);
    }
  },
});
